import { Link } from 'react-router-dom';
import { categories } from '@/mocks/laceData';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="mx-auto" style={{ maxWidth: '1280px' }}>
        <div className="text-center mb-12">
          <p className="text-primary-500 text-sm tracking-[0.2em] uppercase mb-3 font-label">Explore Categories</p>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-4">
            蕾丝品类探索
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            深入了解不同蕾丝品类的独特魅力，从面料工艺到穿搭指南，全方位满足您对蕾丝的好奇与热爱。
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <h3 className="absolute bottom-4 left-4 font-heading text-lg md:text-xl font-semibold text-background-50">
                  {cat.name}
                </h3>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-sm text-primary-500 font-medium group-hover:gap-2 transition-all duration-200">
                  了解更多 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}